module.exports = __webpack_public_path__ + "img/3.cb518d4e.png";